import script from "./VensoDeliveryImageZone.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoDeliveryImageZone.vue?vue&type=script&setup=true&lang=ts"

import "./VensoDeliveryImageZone.vue?vue&type=style&index=0&id=117fcab4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117fcab4"]])

export default __exports__